import { ScrollView, Text } from 'react-native'

export default function Page() {
  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic">
      <Text>我的模板</Text>
    </ScrollView>
  )
}
